import React from 'react';
import { withRouter } from 'found';
import PropTypes from 'prop-types';
import { commitMutation, graphql } from 'react-relay';
import styles from '../Document.scss';
import Header from './Header';
import MobileSidebar from 'react-sidebar';
import Sidebar from '../../App/SidebarComponent';
import NotFound from '../../App/404';
import { Loader } from '../../Elements';
import { Container, Divider, Grid, Rail, Segment } from 'semantic-ui-react';
import Schedule from './Schedule';
import LineItems from './LineItems';
import Library from './Library';
import Brand from './Brand';
import Logo from './Logo';
import Recipient from './Recipient';
import Actions from './Actions';
import Notes from './Notes';
import { RootConsumer } from '../../RootComponent';

const Estimate = class Estimate extends React.Component {
  static propTypes = {
    node: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    viewer: PropTypes.object,
    params: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.canEdit = this.canEdit.bind(this);
    this.hasRecipient = this.hasRecipient.bind(this);
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);

    this.state = {
      error: !this.props.node,
      sidebarOpen: false
    };
  }

  componentWillMount() {
    if (!this.props.node && this.props.location.query.share_token) this.addEstimateToSession();
  }

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }

  addEstimateToSession() {
    this.setState({ error: false });
    const onCompleted = () => {
      this.props.relay.refetch(
        (fragmentVariables) => fragmentVariables, null
      );
    };

    const onError = () => {
      this.setState({ error: true });
    };

    const mutation = graphql`
      mutation EstimateComponent_addEstimateToSessionMutation(
        $input: AddEstimateToSessionInput!
      ) {
        addEstimateToSession(input: $input) {
          estimate {
            id
          }
        }
      }
    `;

    const environment = this.props.relay.environment;
    const { share_token } = this.props.location.query;

    commitMutation(environment, {
      mutation,
      variables: { input: { share_token } },
      onCompleted,
      onError
    });
  }

  toggleSidebar(ev) {
    ev.preventDefault();
    this.onSetSidebarOpen(!this.state.sidebarOpen);
  }

  canEdit() {
    return this.props.node.can_edit && this.props.params.action === 'edit';
  }

  hasRecipient() {
    const { node } = this.props;
    return (node.recipient_first_name ||
      node.recipient_last_name ||
      node.recipient_company_name ||
      node.recipient_phone ||
      node.recipient_email ||
      node.recipient_address) && true;
  }

  render() {
    const ActionsMenu = (
      <RootConsumer>
        {({ window }) =>
          <Actions
            node={this.props.node}
            params={this.props.params}
            relay={this.props.relay}
            router={this.props.router}
            windowDimensions={window}
          />}
      </RootConsumer>
    );

    return (
      <RootConsumer>
        {({ isComputer, isLargeScreen, isMobile, window }) =>
          <div>
            {this.props.node &&
              <MobileSidebar
                sidebar={
                  <Sidebar
                    setSidebarOpenState={this.onSetSidebarOpen}
                    router={this.props.router}
                    viewer={this.props.viewer}
                  />
                }
                sidebarClassName={styles.sidebar}
                open={this.state.sidebarOpen}
                onSetOpen={this.onSetSidebarOpen}
                touch={false}
                contentClassName={styles.mobileSidebarContent}
                rootClassName={styles.mobileSidebarRoot}
              >
                <Header
                  toggleSidebar={this.toggleSidebar}
                  sidebarOpen={this.state.sidebarOpen}
                  document={this.props.node}
                  relay={this.props.relay}
                  router={this.props.router}
                  params={this.props.params}
                  viewer={this.props.viewer}
                  windowDimensions={window}
                />
                <Container className={styles.container}>
                  {!isLargeScreen && isComputer &&
                    <Grid>
                      <Grid.Row columns='equal' className={styles.actionsMenuTablet}>
                        <Grid.Column>
                          {ActionsMenu}
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>}
                  <Segment className={styles.segment}>
                    {isLargeScreen &&
                      <Rail position='right' close className={styles.actionsMenuDesktop}>
                        {ActionsMenu}
                      </Rail>}
                    <Grid padded relaxed stackable>
                      <Grid.Row
                        columns='equal'
                        verticalAlign='bottom'
                        style={{ paddingBottom: 0 }}
                      >
                        <Grid.Column>
                          <Logo
                            canEdit={this.canEdit()}
                            viewer={this.props.viewer}
                            node={this.props.node}
                            relay={this.props.relay}
                          />
                        </Grid.Column>
                        <Grid.Column only='tablet computer' textAlign='right'>
                          {(this.hasRecipient() || this.canEdit()) &&
                            <h3 className={styles.to}>To:</h3>}
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row columns='equal'>
                        <Grid.Column>
                          <Brand
                            canEdit={this.canEdit()}
                            viewer={this.props.viewer}
                            node={this.props.node}
                            relay={this.props.relay}
                          />
                        </Grid.Column>
                        <Grid.Column only='mobile' style={{ paddingBottom: 0 }}>
                          {(this.hasRecipient() || this.canEdit()) &&
                            <h3 className={styles.to}>To:</h3>}
                        </Grid.Column>
                        <Grid.Column textAlign={isMobile ? 'left' : 'right'}>
                          <Recipient
                            canEdit={this.canEdit()}
                            viewer={this.props.viewer}
                            node={this.props.node}
                            relay={this.props.relay}
                          />
                        </Grid.Column>
                      </Grid.Row>
                      {(this.canEdit() || this.props.node.estimate_event_segments.edges.length > 0) &&
                        <Grid.Row className={styles.section}>
                          <Grid.Column width={16}>
                            <Divider horizontal className={styles.heading}>Schedule</Divider>
                          </Grid.Column>
                        </Grid.Row>}
                      <Grid.Row columns='equal'>
                        <Grid.Column>
                          <Schedule
                            estimateEventSegments={this.props.node.estimate_event_segments.edges}
                            viewer={this.props.viewer}
                            relay={this.props.relay}
                            readOnly={!this.canEdit()}
                            node={this.props.node}
                          />
                        </Grid.Column>
                      </Grid.Row>
                      {(this.canEdit() || this.props.node.estimate_line_items.edges.length > 0) &&
                        <Grid.Row className={styles.section}>
                          <Grid.Column width={16}>
                            <Divider horizontal className={styles.heading}>Line Items</Divider>
                          </Grid.Column>
                        </Grid.Row>}
                      <Grid.Row columns='equal' className={styles.section}>
                        <Grid.Column>
                          <LineItems
                            canHideTotal={this.props.viewer && this.props.viewer.features.hide_estimate_total}
                            node={this.props.node}
                            relay={this.props.relay}
                            canEdit={this.canEdit()}
                          />
                        </Grid.Column>
                      </Grid.Row>
                      {this.canEdit() &&
                        <Grid.Row columns='equal'>
                          <Grid.Column>
                            <Library
                              node={this.props.node}
                              relay={this.props.relay}
                              viewer={this.props.viewer}
                            />
                          </Grid.Column>
                        </Grid.Row>}
                      {(this.canEdit() || this.props.node.notes) &&
                        <Grid.Row className={styles.section}>
                          <Grid.Column width={16}>
                            <Divider horizontal className={styles.heading}>
                              Notes
                            </Divider>
                          </Grid.Column>
                        </Grid.Row>}
                      {(this.canEdit() || this.props.node.notes) &&
                        <Grid.Row columns='equal'>
                          <Grid.Column>
                            <Notes
                              node={this.props.node}
                              relay={this.props.relay}
                              canEdit={this.canEdit()}
                            />
                          </Grid.Column>
                        </Grid.Row>}
                    </Grid>
                  </Segment>
                </Container>
              </MobileSidebar>}
              {!this.props.node &&
                <div>
                  {this.state.error &&
                    <NotFound viewer={this.props.viewer} />}
                  {!this.state.error && <Loader />}
                </div>}
          </div>}
      </RootConsumer>
    );
  }
};

export default withRouter(Estimate);



// WEBPACK FOOTER //
// ./webpack/components/Document/Estimate/EstimateComponent.js